import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import config from '../../../../config'
import { PRECISION } from './constants'

import hocConnect from './hocConnect'

@hocConnect
export default class Date extends PureComponent {
    static propTypes = {
        date: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        locale: PropTypes.string.isRequired,
        precision: PropTypes.string,
    }

    static defaultProps = {
        date: null,
        precision: 'days',
    }

    selectFormat = () => {
        const { locale, precision } = this.props

        switch (precision) {
            case PRECISION.SECOND: {
                return locale === config.languages.en.key ? 'MM/DD/YYYY HH:mm:ss' : 'DD. MM. YYYY HH:mm:ss'
            }
            case PRECISION.MINUTE: {
                return locale === config.languages.en.key ? 'MM/DD/YYYY HH:mm' : 'DD. MM. YYYY HH:mm'
            }
            case PRECISION.HOUR: {
                return locale === config.languages.en.key ? 'MM/DD/YYYY HH:00' : 'DD. MM. YYYY HH:00'
            }
            case PRECISION.DAY: {
                return locale === config.languages.en.key ? 'MM/DD/YYYY' : 'DD. MM. YYYY'
            }
            case PRECISION.MONTH: {
                return locale === config.languages.en.key ? 'MM/YYYY' : 'MM. YYYY'
            }
            case PRECISION.YEAR: {
                return 'YYYY'
            }
            default:
                return 'L'
        }
    }

    formatDate = () => {
        const { date, locale } = this.props

        return moment(date).locale(locale).format(this.selectFormat())
    }

    render() {
        const { date } = this.props

        return date && <div>{this.formatDate()}</div>
    }
}
